import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Account() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated.");
      setCur(""); setNext(""); setConfirm("");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-lg space-y-8">
      <div>
        <p className="font-mono text-xs uppercase tracking-widest text-slate-400">Account</p>
        <h1 className="mt-1 font-display text-3xl font-bold text-slate-900">Account</h1>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-6 space-y-2">
        <Row label="Name" value={user?.name} />
        <Row label="Email" value={user?.email} />
        <Row label="Student ID" value={user?.student_id} />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <h2 className="font-display text-lg font-semibold text-slate-900">Change password</h2>
        <form onSubmit={submit} className="mt-4 space-y-4" data-testid="change-password-form">
          <div>
            <Label htmlFor="cur">Current password</Label>
            <Input id="cur" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required
              data-testid="current-password-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="next">New password</Label>
            <Input id="next" type="password" value={next} onChange={(e) => setNext(e.target.value)} required
              data-testid="new-password-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="confirm">Confirm new password</Label>
            <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
              data-testid="confirm-password-input" className="mt-1.5" />
          </div>
          <Button type="submit" disabled={busy} data-testid="change-password-submit" className="bg-slate-900 hover:bg-slate-800">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between py-1.5 text-sm">
      <span className="text-slate-500">{label}</span>
      <span className="text-slate-900 font-medium">{value || "—"}</span>
    </div>
  );
}
